import React from 'react';
import styled from 'styled-components';

import { Button } from '@lt/components';

interface ILinkButton {
  href: string;
  children: React.ReactNode;
  size?: string;
  className?: string;
}

const LinkButton: React.FC<ILinkButton> = ({
  href,
  children,
  size,
  className,
}) => (
  <StyledLink href={href} target="_blank" className={className}>
    <StyledButton size={size}>{children}</StyledButton>
  </StyledLink>
);

const StyledLink = styled.a`
  text-decoration: none;
`;

const StyledButton = styled(Button)`
  font-size: 14px;
`;

export default LinkButton;
